import React, { useState } from 'react';

import { Box, Button, Divider, Flex, Icon, Text } from '@opendoor/bricks/core';

import { Modal } from 'platform/bricks/Modal';

import { AGENT_OFFER_PORTAL_URL } from 'shared/helpers/globals';
import { useMobileDevice } from 'shared/helpers/hooks/useMobileDevice';

import { CustomerCareContactCard } from 'buying/components/buyDirectCheckout/CustomerCareContactCard';

/**
 * Own agent section module
 * storybook-check-ignore
 */
export const OwnAgent = React.memo(() => {
  const { isMobile } = useMobileDevice();
  const [isLinkCopiedModalOpen, setIsLinkCopiedModalOpen] = useState(false);
  const handleOnShareWithAgent = () => {
    setIsLinkCopiedModalOpen(true);
    navigator.clipboard.writeText(AGENT_OFFER_PORTAL_URL);
  };
  const onRequestClose = () => setIsLinkCopiedModalOpen(false);
  return (
    <Flex flexDirection="column" alignItems={isMobile ? 'center' : undefined}>
      <Flex
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="flex-start"
        width={['100%', null, '100%']}
      >
        <Text size={isMobile ? '160' : '150'} fontWeight="medium" alignSelf="flex-start" mb={8}>
          Make an offer with your agent
        </Text>
        <Text size="110" fontWeight="regular" alignSelf="flex-start" mb={8}>
          If you committed to working with that agent, share the home with them so they can submit
          an offer for you.
        </Text>
        <Button
          alignSelf={['center', null, 'flex-start']}
          analyticsName="buy-direct-checkout-share-with-agent"
          aria-label="Share with agent"
          data-testid="buy-direct-checkout-share-with-agent-button"
          width={['100%', null, '50%']}
          variant="secondary"
          onClick={handleOnShareWithAgent}
          mt={4}
          mb={8}
          mr={[null, null, 8]}
        >
          Share with agent
        </Button>
      </Flex>
      <Divider width="100%" />
      <Flex flexDirection="column" justifyContent="flex-start" my={4} width="100%">
        <Text size={isMobile ? '160' : '150'} py={8} fontWeight="medium">
          Have questions about buying directly from us?
        </Text>
        <Box>
          <CustomerCareContactCard />
        </Box>
      </Flex>
      <Modal
        analyticsName="cake-buy-direct-own-agent-link-copied-modal"
        id="buy-direct-own-agent-link-copied-modal"
        aria-label="Link copied modal"
        isOpen={isLinkCopiedModalOpen}
        onRequestClose={onRequestClose}
        hasPadding={true}
        headerProps={{
          rightComponent: (
            <Button
              variant="icon"
              onClick={onRequestClose}
              analyticsName="buy-direct--own-agent-linked-copied-close-modal"
              aria-label="Close modal"
            >
              <Icon name="close" size={12} />
            </Button>
          ),
        }}
        desktopAndTabletSize="sm"
        mobileSize="sheet"
      >
        <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
          <Text size="s3" fontWeight="bold" mb={4} ml={8}>
            Link copied.
          </Text>
          <Text size="s1" fontWeight="regular" mb={8} ml={8}>
            Please email the link with your agent or text it.
          </Text>
          <Button
            alignSelf="center"
            analyticsName="buy-direct-own-agent-link-copied-cta"
            aria-label="I got it"
            data-testid="buy-direct-own-agent-link-copied-button"
            width={['80%', null, '50%']}
            variant="primary"
            onClick={onRequestClose}
            mt={4}
            mb={8}
            mr={[null, null, 8]}
          >
            I got it
          </Button>
        </Flex>
      </Modal>
    </Flex>
  );
});

OwnAgent.displayName = 'OwnAgent';
